// CTA finale unica — grande, spaziosa, mauve.
// Testi/link sovrascrivibili via /admin/landing-config.
import { useLandingConfig } from "@/hooks/useLandingConfig";

export default function LandingCTA() {
  const { T } = useLandingConfig();
  const WHATSAPP_URL = T("cta_links.cta_final_href", "") || T("cta_links.whatsapp_url", "https://wa.me/393292561466?text=Ciao%20Epic%20Flow!%20Vorrei%20info%20su%20orari%20e%20piani.");
  const eyebrow = T("texts.cta_final.eyebrow", "Restiamo in contatto");
  const t1 = T("texts.cta_final.title_line1", "Il tuo prossimo");
  const t2 = T("texts.cta_final.title_line2", "respiro consapevole");
  const t3 = T("texts.cta_final.title_line3", "inizia qui.");
  const italicWord = T("texts.cta_final.title_italic_word", "");
  const subtitle = T("texts.cta_final.subtitle", "Scrivici su WhatsApp per ricevere il palinsesto aggiornato, disponibilità e i pacchetti pensati per te.");
  const ctaLabel = T("texts.cta_final.cta_label", "Scrivici su WhatsApp");

  const renderTitleLine = (line, forceItalic = false) => {
    if (forceItalic) return <span className="font-editorial">{line}</span>;
    if (!italicWord || !line?.toLowerCase().includes(italicWord.toLowerCase())) return line;
    const idx = line.toLowerCase().indexOf(italicWord.toLowerCase());
    return (
      <>
        {line.slice(0, idx)}
        <span className="font-editorial">{line.slice(idx, idx + italicWord.length)}</span>
        {line.slice(idx + italicWord.length)}
      </>
    );
  };

  return (
    <section data-testid="landing-cta" className="relative bg-primary text-primary-foreground">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-32 md:py-40 text-center">
        <div className="text-[10px] uppercase tracking-[0.42em] opacity-70 mb-8 flex items-center justify-center gap-3">
          <span className="w-10 h-px bg-current opacity-60" />
          {eyebrow}
          <span className="w-10 h-px bg-current opacity-60" />
        </div>

        <h2 className="font-serif-display font-normal text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight">
          {renderTitleLine(t1)}
          <br />
          {renderTitleLine(t2, !italicWord)}
          <br />
          {renderTitleLine(t3)}
        </h2>

        <p className="mt-10 text-lg md:text-xl opacity-85 max-w-xl mx-auto font-light leading-relaxed">
          {subtitle}
        </p>

        <div className="mt-14">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp"
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-full bg-primary-foreground text-primary text-sm uppercase tracking-[0.28em] hover:bg-primary-foreground/90 transition-all btn-lift"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
              <path d="M17.5 14.4c-.3-.15-1.8-.9-2.07-1-.28-.1-.48-.15-.68.15-.2.3-.78 1-.96 1.2-.18.2-.35.22-.65.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.67-2.09-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.08-.15-.68-1.65-.93-2.25-.25-.6-.5-.51-.68-.52h-.58c-.2 0-.52.08-.8.38-.28.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.1 3.2 5.08 4.5.71.3 1.27.48 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.8-.73 2.05-1.44.25-.7.25-1.3.18-1.44-.08-.13-.28-.2-.58-.35zM12 2C6.48 2 2 6.48 2 12c0 1.9.53 3.67 1.44 5.19L2 22l4.94-1.42A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
            </svg>
            {ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
